import {
  ProfessionalApplicationStatusEnum,
  ReviewProData,
  ReviewProDataApplicationStatus,
} from '@platform/client/schemas';
import {
  ProfileItem,
  ProfileItemLong,
  ProfileLinkExternal,
  ProfileSection,
  ProfileTabContainer,
  ProfileValueColors,
  TeamProfileLink,
} from '../../components/ProfileComponents';
import { formatDateStr } from '../../../dashboard/my-projects/utils';

export const ProfileTabContent = ({ proData }: { proData?: ReviewProData }) => {
  if (!proData) {
    return <div>No professional data available.</div>;
  }
  return (
    <ProfileTabContainer>
      <ProfileSection title='Professional Details'>
        <ProfileItem label='City' value={proData.city} />
        <ProfileLinkExternal label='LinkedIn' href={proData.linkedin} />
        <ProfileItem label='Country' value={proData.country} />
        <ProfileLinkExternal
          label='Email'
          href={`mailto:${proData.email}`}
          displayName={proData.email}
        />
        <ProfileItem label='Employer' value={proData.employer} />
        <ProfileLinkExternal label='Resume' href={proData.resume} />
        <ProfileItem label='Job Title' value={proData.jobTitle} />
        <ProfileItem label='Corporate Client' value={proData.corporateClient} />
        <ProfileItem
          label='Experience Years'
          value={proData.experienceYears ? proData.experienceYears.toString() : ''}
        />
        <ProfileItem label='Cohort' value={proData.cohortName} />
        <ProfileItem label='Work Type' value={proData.workType} />
        <ProfileItem label='Team Opt In' value={proData.teamOptIn ? 'Yes' : 'No'} />
        <ProfileItem label='Board Area' value={proData.boardArea} />
        <TeamProfileLink cohortId={proData.cohortId} teamId={proData.teamId} />
        <ApplicationStatusItem
          applicationStatus={proData.applicationStatus}
          isDisabled={proData.isDisabled}
        />
        <ProfileItem
          label='Application Date'
          value={proData.applicationDate ? formatDateStr(proData.applicationDate) : 'N/A'}
        />
      </ProfileSection>
      <ProfileSection title='Professional Skills' columns={1}>
        <ProfileItem label='Languages' value={proData.languages?.join(', ')} />
        <ProfileItem label='Skills' value={proData.skills?.join(', ')} />
        <ProfileItem label='SDGs' value={proData.causes?.join(', ')} />
        <ProfileItem label='Industries' value={proData.industries?.join(', ')} />
        <ProfileItemLong label='Skills Explanation' value={proData.skillsExplanation} />
      </ProfileSection>
    </ProfileTabContainer>
  );
};

const ApplicationStatusItem = ({
  applicationStatus,
  isDisabled = false,
}: {
  applicationStatus?: ReviewProDataApplicationStatus;
  isDisabled?: boolean;
}) => {
  let color: ProfileValueColors = 'default';
  if (isDisabled || applicationStatus === ProfessionalApplicationStatusEnum.rejected) {
    color = 'error';
  } else if (applicationStatus === ProfessionalApplicationStatusEnum.approved) {
    color = 'success';
  } else if (applicationStatus === ProfessionalApplicationStatusEnum.waitlisted) {
    color = 'warning';
  }
  return (
    <ProfileItem
      label='Application Status'
      value={isDisabled ? 'Disabled' : applicationStatus}
      color={color}
    />
  );
};
